import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "../../data/services";
import Reveal from "../Reveal";

export const Projects = () => {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="relative z-10 py-24 md:py-32 bg-[#f4f3ee] border-t border-black/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#2f4bff]">
            / Selected work
          </span>
          <h2 className="mt-5 font-head text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight max-w-2xl leading-[1.02] text-[#111111]">
            Projects I&apos;ve shipped.
          </h2>
          <p className="mt-5 font-body text-lg text-neutral-600 max-w-xl leading-relaxed">
            A sample of real applications I&apos;ve designed, built and
            modernized across enterprise, healthcare, government and robotics.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.id} delay={(i % 2) * 0.07}>
              <article
                data-testid={`project-card-${p.id}`}
                className="group h-full flex flex-col bg-white border border-black/10 p-8 md:p-10 hover:border-[#2f4bff] hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex items-center justify-between gap-4">
                  <span className="font-mono-tech text-xs uppercase tracking-[0.15em] text-[#2f4bff]">
                    {p.org}
                  </span>
                  <span className="font-mono-tech text-xs text-neutral-400">
                    {p.year}
                  </span>
                </div>

                <h3 className="mt-6 font-head text-2xl md:text-3xl font-semibold tracking-tight text-[#111111] leading-tight">
                  {p.title}
                </h3>
                <p className="mt-2 font-mono-tech text-xs uppercase tracking-[0.12em] text-neutral-500">
                  {p.role}
                </p>

                <p className="mt-5 font-body text-neutral-600 leading-relaxed flex-1">
                  {p.description}
                </p>

                <div className="mt-7 flex flex-wrap gap-2">
                  {p.tags.map((t) => (
                    <span
                      key={t}
                      className="font-mono-tech text-[11px] uppercase tracking-[0.1em] text-neutral-600 border border-black/15 px-2.5 py-1"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12">
            <a
              href="/contact"
              data-testid="projects-contact-link"
              className="group inline-flex items-center gap-2 font-mono-tech text-xs uppercase tracking-[0.15em] text-[#111111] border border-black/20 px-6 py-4 hover:border-[#2f4bff] hover:text-[#2f4bff] transition-colors"
            >
              Want the full story? Get in touch
              <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Projects;
